// lib/analytics.ts - Centralized analytics configuration

// LinkedIn tracking configuration
export const LINKEDIN_PARTNER_ID = "6572377"

// Facebook/Meta pixel ID
export const META_PIXEL_ID = "1034066861224856"

// Custom tracking ID
export const CUSTOM_TRACKING_ID =
  "aa751aed52f91785534b0093667c03d1520ccc2ac83da3f311fc1b165845bfc8&puid=j9o6749k1aw5qp00hyr9yh2zzx0nfdjxndhf1ko7c8p4sgz6k5tuweqrpctuu395"

// Track page view - can be called from pages
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function trackPageView(path?: string, title?: string): void {
  // Call any custom tracking functions here
  if (typeof window !== "undefined") {
    // Facebook/Meta tracking
    if (window.fbq) {
      window.fbq("track", "PageView")
    }

    // LinkedIn tracking
    if (window.lintrk) {
      if (typeof window.lintrk === "function") {
        window.lintrk("track", { conversion_id: LINKEDIN_PARTNER_ID })
      } else if (window.lintrk && "q" in window.lintrk) {
        window.lintrk.q.push(["track", { conversion_id: LINKEDIN_PARTNER_ID }])
      }
    }
  }
}

// Extend Window interface to include analytics properties
declare global {
  interface Window {
    // Facebook Pixel
    fbq: (command: string, event: string, params?: Record<string, unknown>) => void
    _fbq?: unknown

    // LinkedIn Tracking
    lintrk:
      | ((command: string, params: Record<string, unknown>) => void)
      | {
          q: Array<[string, Record<string, unknown>]>
          ready: boolean
        }
    _linkedin_data_partner_ids?: string[]

    // Google Analytics
    gtag: (command: string, ...args: unknown[]) => void
    dataLayer: unknown[]

    // HubSpot
    _hsq?: unknown[]

    // Custom tracking
    tolt_referral?: string
    tolt_referral_ready?: Event
  }
}

